import React, { useState } from 'react'
import PropTypes from 'prop-types'

const ListeMatchs = ({children, titre, collapsedByDefault = false}) => {
    const [isCollapsed, setIsCollapsed] = useState(collapsedByDefault);

    return (
        <div className="flex flex-col gap-4 p-6 my-6 bg-[#272727] rounded-lg shadow-lg w-full">
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="flex items-center justify-between w-full hover:opacity-80 transition-opacity text-left"
            >
                <h2 className="text-white font-semibold text-xl font-poppins">{titre}</h2>
                <span className={`text-white text-2xl transition-transform duration-300 ${isCollapsed ? 'rotate-0' : 'rotate-180'}`}>
                    ▼
                </span>
            </button>
            
            {!isCollapsed && (
                <div className="flex flex-col gap-4">
                    {children}
                </div>
            )}
        </div>
    )
}

ListeMatchs.propTypes = {
    children: PropTypes.node,
    titre: PropTypes.string,
    collapsedByDefault: PropTypes.bool,
}

ListeMatchs.defaultProps = {
    children: null,
    titre: 'Matchs',
    collapsedByDefault: false,
};

export default ListeMatchs;

